/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-FocusZoneListExample .ms-DetailsRow{display:block}"}]);
/* tslint:enable */